import React from "react";

import { Box, Theme, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    width: "100%",
    marginRight: theme.spacing(6),
  },
  container: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(2, 1),
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: "bold",
    whiteSpace: "nowrap",
  },
  caption: {
    fontSize: theme.typography.pxToRem(14),
    textTransform: "capitalize",
    color: theme.palette.text.secondary,
    fontWeight: 600,
    marginRight: theme.spacing(3),
  },
}));

type Props = {
  title: string;
  value: string | React.ReactNode;
  unit?: string | React.ReactNode;
};

const AccordionDetailsItem: React.FC<Props> = ({ title, value, unit }) => {
  const { classes } = useStyles();
  return (
    <Box className={classes.root}>
      <Box className={classes.container}>
        <Typography className={classes.caption}>{title}</Typography>
        <div className={classes.secondaryHeading}>
          {value}
          {unit}
        </div>
      </Box>
    </Box>
  );
};

export default AccordionDetailsItem;
